import { render, staticRenderFns } from "./MicrosoftFlat.vue?vue&type=template&id=783298fb"
import script from "./MicrosoftFlat.vue?vue&type=script&lang=js"
export * from "./MicrosoftFlat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports